import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from 'framer-motion';

import { useWindowDimensions } from '../hooks/useWindowDimensions';
import { updateIndexMapTransform, updateIndexPage } from '../store/globalReducer';

import WelcomeScreen from '../components/WelcomeScreen';

import Map from '../components/Map';

import '../assets/scss/components/map.scss';
import '../assets/scss/pages/index.scss';

import indexMap from '../assets/img/index/map_index.jpg';

export default function Index() {
  const location = useLocation();
  const dispatch = useDispatch();

  const { winWidth, winHeight } = useWindowDimensions();
  const indexPinList = useSelector(state => state.temples.templeData.filter(el => el.show_on_map === 'index'));
  const indexMapTransform = useSelector(state => state.global.indexMapTransform);

  useEffect(() => dispatch(updateIndexPage(true)), []);

  return (
    <div className="page-map">
      <WelcomeScreen />
      <Map
        isIndex={true}
        mapImage={indexMap}
        pinList={indexPinList}
        mapTransform={{ x: winWidth <= 480 ? -650 : 0, y: 0 }}
        updateMapTransform={updateIndexMapTransform}>
      </Map>
    </div>
  );
}